export const DiagnosticsConstants = {
  RequestDiagnosticsOverview: 'DIAGNOSTICS_CONSTANTS.REQUEST_DIAGNOSTICS_OVERVIEW',
  ReceiveDiagnosticsOverview: 'DIAGNOSTICS_CONSTANTS.RECEIVE_DIAGNOSTICS_OVERVIEW',
  RequestDiagnosticsRegistries: 'DIAGNOSTICS_CONSTANTS.REQUEST_DIAGNOSTICS_REGISTRIES',
  ReceiveDiagnosticsRegistries: 'DIAGNOSTICS_CONSTANTS.RECEIVE_DIAGNOSTICS_REGISTRIES',
  UpdateDiagnosticsDataRegistries: 'DIAGNOSTICS_CONSTANTS.UPDATE_DIAGNOSTICS_DATA_REGISTRIES',
  RemoveDiagnosticsDataRegistries: 'DIAGNOSTICS_CONSTANTS.REMOVE_DIAGNOSTICS_DATA_REGISTRIES',
  UpdateGraphDateRange: 'DIAGNOSTICS_CONSTANTS.UPDATE_GRAPH_DATE_RANGE',
  UpdateLineColorsObj: 'DIAGNOSTICS_CONSTANTS.UPDATE_LINE_COLOR_OBJ',
  UpdateAvailableColors: 'DIAGNOSTICS_CONSTANTS.UPDATE_AVAILABLE_COLORS',
  SetCustomDataPointsList: 'DIAGNOSTICS_CONSTANTS.SET_CUSTOM_DATA_POINTS_LIST',
  SetDiagnosticsError: 'DIAGNOSTICS_CONSTANTS.SET_DIAGNOSTICS_ERROR',
  ClearDiagnosticsError: 'DIAGNOSTICS_CONSTANTS.CLEAR_DIAGNOSTICS_ERROR',
  UpdateSelectedDataPointsList: 'DIAGNOSTICS_CONSTANTS.UPDATE_SELECTED_DATA_POINTS_LIST',
};

interface Point {
  x: string;
  actual: number;
}

interface DataPoint {
  graph_data: Point[];
  id: string;
  name: string;
  tag: string;
  unit: string;
}

export interface DiagnosticsData {
  data_points: DataPoint[];
  date: string;
  interval: string;
  name: string;
  slug: string;
}

export interface DataPointListObj {
  api_location: string;
  display_name: string;
  id: number;
  is_darksky_data: boolean;
  is_default: boolean;
  modbus_device: number;
  modbus_register: number;
  modbus_register_number: number;
  status: string;
  tag: string;
  update_api_location: string;
}

export interface GraphDateRange {
  value: string;
  label: string;
  startDatetime?: string;
  endDatetime?: string;
}
